// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"961da63b","963":"9184ab9b"}[chunkId] + ".chunk.js";
};